/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ContactForPageViewDto { 
    /**
     * Тип контакта
     */
    contactTypeId?: number;
    /**
     * Контакт для связи.
     */
    contact?: string;
    /**
     * Описание.
     */
    description?: string;
    /**
     * Приоритет.
     */
    isPriority?: boolean;
    /**
     * Сортировка.
     */
    sortOrder?: number;
    isRequired?: boolean;
    id?: string;
    customListValueId?: string;
    customListId?: string;
}

